import React from 'react';

import { Checkbox, CheckboxProps } from '$shared/components';

export type RadioProps = Omit<CheckboxProps, 'type'>;

export const Radio = React.forwardRef<HTMLInputElement, RadioProps>((props, ref) => (
    <Checkbox ref={ref} type="radio" {...props} />
));
